import { memo, useState } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    makeStyles,
    withStyles
} from '@material-ui/core';
// import Link from 'next/link';
import { useTranslation } from 'src/app/i18n';
// import { useAuth } from 'src/providers/auth/AuthProvider';
import { MobileNavTypography } from './styledComponent';
import { AppModelsSidebar, AboutSidebar, PricingSidebar } from './SidebarComponents';
// import { AuthSidebar } from './AuthSidebar';
import clsx from 'clsx';
const useSmallSide = makeStyles(() => ({
    summary: { justifyContent: 'flex-end', alignItems: 'center' },
    accordion: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        width: '100%',
        '&:first-child': {
            borderRadius: 0
        },
        '&:last-child': {
            borderRadius: 0
        }
    },
    activeAcoordion: {},
    detail: { flexDirection: 'column', alignItems: 'flex-start' }
}));
const BorderBox = withStyles((theme) => ({
    root: { flex: 1, height: 1, margin: '0 16px', backgroundColor: theme.palette.primary.light }
}))(Box);

// const SmallSidebarButton = withStyles({
//     root: { alignSelf: 'flex-end', padding: '12px 16px' }
// })(MobileNavTypography);

const TopBorder = ({ title, active }: any) => (
    <>
        {active && <BorderBox />}
        <MobileNavTypography>{title}</MobileNavTypography>
    </>
);

const MyAccordion = ({
    expanded,
    pageKey,
    handleChange,
    title,
    children
}: AppCommonChild & {
    title: string;
    expanded: any;
    pageKey: string;
    handleChange?: any;
}) => {
    const classes = useSmallSide();
    const active = expanded === pageKey;
    return (
        <Accordion
            expanded={active}
            onChange={handleChange && handleChange(pageKey)}
            className={clsx(classes.accordion, {
                [classes.activeAcoordion]: active
            })}>
            <AccordionSummary expandIcon={null} classes={{ content: classes.summary }}>
                <TopBorder title={title} active={active} />
            </AccordionSummary>
            <AccordionDetails className={classes.detail}>{children}</AccordionDetails>
            <BorderBox />
        </Accordion>
    );
};

export const SmallScreenSide = memo(() => {
    const [expanded, setExpanded] = useState<string | false>(false);
    const handleChange = (panel: string) => (_: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };
    const { t } = useTranslation('common');
    // const { user, signOut } = useAuth();

    return (
        <>
            <MyAccordion
                expanded={expanded}
                handleChange={handleChange}
                title={t('nav.appModels')}
                pageKey="appModels">
                <AppModelsSidebar />
            </MyAccordion>

            <MyAccordion
                expanded={expanded}
                handleChange={handleChange}
                title={t('nav.about')}
                pageKey="about">
                <AboutSidebar />
            </MyAccordion>
            <MyAccordion
                expanded={expanded}
                handleChange={handleChange}
                title={t('nav.pricing')}
                pageKey="pricing">
                <PricingSidebar />
            </MyAccordion>
            {/* <Link href="/how-it-works">
                <SmallSidebarButton>{t('nav.howWorks')}</SmallSidebarButton>
            </Link> */}
            {/* {!!user ? (
                <SmallSidebarButton onClick={() => signOut()}>{t('nav.logout')}</SmallSidebarButton>
            ) : (
                <MyAccordion
                    expanded={expanded}
                    handleChange={handleChange}
                    title={t('nav.login')}
                    pageKey="login">
                    <AuthSidebar mode="LOGIN" />
                </MyAccordion>
            )} */}
        </>
    );
});
